import type { ProductListItem } from '@/productBrowser/productBrowserTypes';
import type { Brand } from '@whiz-cart/node-shared/models/brand/brand';
import localforage from 'localforage';
import { Store, StorePersist } from 'schummar-state/react';

const storage = localforage.createInstance({ name: 'appState' });

type recentStoreItems = {
    [storeGuid: string]: { items: ProductListItem[] };
};

export type CartSorting = { by: 'active' | 'lastSeen' | 'battery'; order: 'asc' | 'desc' };

export const appState = new Store({
    recentProducts: {} as recentStoreItems,
    navigationGroupsCollapse: {} as { [groupName: string]: boolean },
    navigationItemsOpen: {} as { [path: string]: boolean },
    pinnedNavigationItems: [] as string[],
    cartSorting: undefined as CartSorting | undefined,
    overrideBrand: undefined as Brand | undefined,
});

export const appStatePersist = new StorePersist(appState, storage, {
    paths: ['recentProducts', 'navigationGroupsCollapse', 'navigationItemsOpen', 'pinnedNavigationItems', 'cartSorting'],
});

if (typeof window !== 'undefined') {
    Object.assign(window, { appState, appStatePersist });
}
